import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/salary-structure/v1";

export const getSalaryStructure = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createSalaryStructure(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getSalaryStructureAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getSalaryStructureDetail(id) {
  return GETDetail(API_URL, id);
}

export function editSalaryStructure(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archiveSalaryStructure(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveSalaryStructure(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteSalaryStructure(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}